import React from 'react';
import { Chip, Tooltip, Typography } from '@mui/material';
import { styled, keyframes } from '@mui/system';

const shimmer = keyframes`
  0% {
    transform: translateX(-200px);
  }
  100% {
    transform: translateX(200px);
  }
`;

const StyledChip = styled(Chip)({
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: 'rgba(42,42,42,1)',
  height: "20px",
  width: "130px",
  color: '#fff',
  fontWeight: 'bold',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-50%',
    width: '50%',
    height: '100%',
    background:
      'linear-gradient(120deg, transparent 0%, rgba(255,255,255,0.15) 50%, transparent 100%)',
    transform: 'skewX(-20deg)',
    animation: `${shimmer} 10s ease-in infinite`,
    zIndex: 2,
  },
  '& .MuiChip-label': {
    position: 'relative',
    zIndex: 3,
  },
  '&:hover' :{
    cursor: "default"
  }
});

const ShinyChip = (props) => {
  const { label, icon, toolTip} = props
  
  if(toolTip){
    return (
        <Tooltip 
          placement={"bottom"}
          title={<Typography variant='h6' style={{padding: "4px 8px"}}>{toolTip}</Typography>} arrow>
            <StyledChip label={label} icon={icon} />
        </Tooltip>
    )
  }
  else {
    return (
      <StyledChip label={label} icon={icon} />
    )
  }
}

export default ShinyChip;
